(function ($) {
    $(function () {
        /*--------------------------------
        * 記事スライダー
        --------------------------------*/
        if (0 < $('.js-article-slider').length) {
            $('.js-article-slider').slick({
                autoplay: true, // 自動再生ON
                dots: false, // ドットインジケーターON
                //centerMode: true, // 両サイドに前後のスライド表示
                centerPadding: '0', // 左右のスライドのpadding
                cssEase: "linear",
                autoplaySpeed: 6000,
                slidesToShow: 5,
                speed: 200,
                swipe: true,
                arrows: true,
                variableWidth: true,
                // pauseOnFocus: false,
                // pauseOnHover: false,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        //variableWidth: false,
                    }
                }]
            }).on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                var direction = (nextSlide > currentSlide) ? 'next' : 'prev';
                // 最後の要素の場合
                direction = ('prev' === direction && 0 === nextSlide && 1 !== currentSlide)? 'next' : direction;
                // 変化中フラグON
                if ('prev' === direction) {
                    $('.js-article-slider').find('.slick-prev').addClass('--changing');
                } else {
                    $('.js-article-slider').find('.slick-next').addClass('--changing');
                }
                // がたつき防止
                $('.js-article-slider').find(".slick-slide").each((index, el) => {
                    const $this = $(el),
                    slickindex = $this.attr("data-slick-index");
                    if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
                        if (slickindex == "-1") {
                            $this.addClass("is-active-next");
                        } else {
                            $this.removeClass("is-active-next");
                        }
                    } else if (nextSlide == 0) {
                        if (slickindex == slick.slideCount) {
                            $this.addClass("is-active-next");
                        } else {
                            $this.removeClass("is-active-next");
                        }
                    } else {
                        $this.removeClass("is-active-next");
                    }
                });
            }).on("afterChange", (event, slick, currentSlide, nextSlide) => {
                // 変化中フラグOFF
                $('.js-article-slider').find('.slick-arrow').removeClass('--changing');
            });
        }

        /*--------------------------------
        * 記事一覧フィルター（セレクトイベント）
        --------------------------------*/
        $('#js-archive-filter').on('change', function(){
            location.href = $(this).val();
        });

        /*--------------------------------
        * 記事ページez-tocのアンカーリンクの調整
        * ※idのspanが付与されることで見出しの::first-letterが
        * iphoneで効かなくなるのでテキストのみをspanでラップ
        --------------------------------*/
        if (0 < $('.ez-toc-section').length && 0 < $('.ez-toc-section').parent('.wp-block-heading').length) {
            $h = $('.ez-toc-section').parent('.wp-block-heading');
            
            $($h).each(function(i, e){
                $(e).wrapInner('<span class="--first-colored">');
                $(e).find('.ez-toc-section').prependTo($(e));
                $(e).find('.ez-toc-section-end').appendTo($(e));
            });
        }


    });
})(jQuery);
